import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../css/components/pre-lander/preLander.css';

const PreLanderStep = ({ stepNumber, question, answer1, answer2, answer1Subtext, onAnswer, gameId, isFinalStep, extraClassName}) => {
	return (
		<div
			className={styles.step}
			data-testid={`pre-lander-step-${stepNumber}`}
		>
			<h2 className={`${styles.question} ${styles[extraClassName]}`}>{question}</h2>
			<div className={`${styles.answers} ${styles[extraClassName]} ${isFinalStep ? styles.singleAnswer : ''}`}>
				<button
					className={`${styles.answerButton} ${styles[extraClassName]} ${isFinalStep ? styles.arrowBoth : styles.arrowLeft} ${styles[gameId]} ${isFinalStep ? styles.finalButton : ''}`}
					onClick={() => onAnswer(1)}
					data-testid="pre-lander-answer-1"
				>
					{answer1Subtext && (
						<span className={styles.buttonSubtext}>{answer1Subtext}</span>
					)}
					<span className={`${styles.buttonMainText} ${styles[extraClassName]}`}>{answer1}</span>
				</button>
				{answer2 && (
					<button
						className={`${styles.answerButton} ${styles[extraClassName]} ${styles.arrowRight} ${styles[gameId]}`}
						onClick={() => onAnswer(2)}
						data-testid="pre-lander-answer-2"
					>
						<span className={`${styles.buttonMainText} ${styles[extraClassName]}`} >{answer2}</span>
					</button>
				)}
			</div>
		</div>
	);
};

PreLanderStep.propTypes = {
	stepNumber: PropTypes.number.isRequired,
	question: PropTypes.string.isRequired,
	answer1: PropTypes.string.isRequired,
	answer2: PropTypes.string,
	answer1Subtext: PropTypes.string,
	onAnswer: PropTypes.func.isRequired,
	gameId: PropTypes.string.isRequired,
	extraClassName: PropTypes.bool,
	isFinalStep: PropTypes.bool,
};

export default PreLanderStep;
